export default __webpack_public_path__ + "static/media/fsk-16-a.7e7d00b8.jpg";